import { render, staticRenderFns } from "./segmentos.vue?vue&type=template&id=36463e6f&scoped=true&"
import script from "./segmentos.vue?vue&type=script&lang=js&"
export * from "./segmentos.vue?vue&type=script&lang=js&"
import style0 from "./segmentos.vue?vue&type=style&index=0&id=36463e6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36463e6f",
  null
  
)

export default component.exports